import { gql } from 'graphql-request';

import {
  TaskNanoID,
  TaskOpenRegular,
  TaskPaidRegular,
  TaskPrice,
  TaskSentRegular,
  TaskSmartContractLastStatusChangeAt
} from '../tasksTypes';

export interface FetchCachePaginatedTasksPriceQueryResponse {
  openRegular: TaskOpenRegular;
  paidRegular: TaskPaidRegular;
  price: TaskPrice;
  sentRegular: TaskSentRegular;
  taskNanoId: TaskNanoID;
  smartContractLastStatusChangeAt: TaskSmartContractLastStatusChangeAt;
}

export const CACHE_FETCH_PAGINATED_TASKS_PRICE_QUERY = gql`
  query CacheIndexTasksPrice(
    $filters: BitTasksPriceFilters
    $sort: [BitTaskPriceSortEnum]
    $limit: Int
    $offset: Int
    $source: String
  ) {
    tasksPrice(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
    ) {
      nodes {
        openRegular
        paidRegular
        price
        sentRegular
        taskNanoId
        smartContractLastStatusChangeAt
      }
      paginationInfo {
        nextPage
        totalCount
      }
    }
  }
`;
